import {
    inject,
    Injectable
} from '@angular/core';

import {
    restManager
} from 'app/ajs-upgraded-providers';

import {
    GetFoliosResponse,
    BedzzleCommonTransaction
} from 'src/app/features/digital-payments';

@Injectable({
    providedIn: 'root'
})
export class BedzzleApiService {
    private readonly restManager = inject(restManager);

    public setupShop(paymentMethodId: number, propertyId: string): Promise<any> {
        return this.restManager.post('bedzzle/setup', { propertyId: propertyId }, { tilbyPaymentId: paymentMethodId });
    }

    public getRoomFolios(paymentMethodId: number): Promise<GetFoliosResponse> {
        return this.restManager.getList('bedzzle/room_folios', { tilbyPaymentId: paymentMethodId });
    }

    public getMiscSalesFolios(paymentMethodId: number): Promise<GetFoliosResponse> {
        return this.restManager.getList('bedzzle/misc_sales_folios', { tilbyPaymentId: paymentMethodId });
    }

    public createTransaction(paymentMethodId: number, transactionData: BedzzleCommonTransaction) {
        return this.restManager.post('bedzzle/transactions', transactionData, { tilbyPaymentId: paymentMethodId });
    }

    public rollbackTransaction(paymentMethodId: number, outletId: string, orderId: string) {
        return this.restManager.deleteOne('bedzzle/transactions', null, { orderId: orderId, outletId: outletId, tilbyPaymentId: paymentMethodId });
    }
};